var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer text-center"},[_vm._v("\n    © 2019 - "+_vm._s((new Date()).getFullYear())+" Borlaug CX    "),_c('i',{staticClass:"fas fa-globe text-light-green"}),_vm._v("    Release "+_vm._s(this.version)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }